import React from 'react';
import { IPLink, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';
import { navigateToExternalUrl } from 'utils/url';

interface IOutlookAttachmentErrorProps {
  text: string;
  taskUrl: string;
}

const OutlookAttachmentError: React.FunctionComponent<IOutlookAttachmentErrorProps> = (
  props: IOutlookAttachmentErrorProps
) => {
  return (
    <IPStack
      verticalFill
      styles={{
        root: {
          position: 'absolute',
          margin: 'auto',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 10,
          zIndex: 999,
        },
      }}
      horizontalAlign="center"
      verticalAlign="center"
    >
      <IPStack.Item>
        <IPStack tokens={globalStackTokensGapSmall}>
          <IPStack.Item>
            <IPText variant="medium">{props.text}</IPText>
            {props.taskUrl && (
              <IPLink
                onClick={() => {
                  navigateToExternalUrl(props.taskUrl, '', '');
                }}
              >
                {props.taskUrl}
              </IPLink>
            )}
          </IPStack.Item>
        </IPStack>
      </IPStack.Item>
    </IPStack>
  );
};

export default OutlookAttachmentError;
